<script setup lang="ts">
import { CircleUser, Menu } from 'lucide-vue-next'

useHead({
  link: [{
    rel: 'preconnect',
    href: 'https://ncore.nebusfinance.ru/moon',
  }],
})

const iframeLoaded = ref(false)

function handleMessage(event: MessageEvent) {
  if (event.origin !== 'https://ncore.nebusfinance.ru')
    return

  if (event.data === 'load') {
    iframeLoaded.value = true
  }
}

function handleIframeLoad() {
  window.addEventListener('message', handleMessage)
}

onUnmounted(() => {
  window.removeEventListener('message', handleMessage)
})
</script>

<template>
  <header class="fixed top-0 left-0 right-0 backdrop-blur-lg bg-white/70 z-[50] md:py-2">
    <div class="container mx-auto px-4 h-16 relative">
      <div class="flex items-center h-full justify-between">
        <!-- Левая часть -->
        <div class="flex items-center gap-4 h-12 z-10">
          <NavMenu />

          <NuxtLink to="/">
            <NuxtImg src="/logo.svg" alt="logo" height="40" class="w-26 h-10" />
          </NuxtLink>

          <div v-if="false" class="relative overflow-hidden size-10 bg-none">
            <div
              v-show="!iframeLoaded"
              class="absolute inset-0 bg-none rounded-full animate-pulse"
            />
            <ClientOnly>
              <iframe
                :class="{ 'opacity-0': !iframeLoaded }"
                src="https://ncore.nebusfinance.ru/moon"
                loading="lazy"
                class="size-10 overflow-hidden bg-none"
                frameborder="0"
                aria-label="3D модель луны"
                allow="autoplay; fullscreen; xr-spatial-tracking"
                style="background: transparent !important; mix-blend-mode: lighten !important;"
                allowtransparency="true"
                importance="low"
                referrerpolicy="strict-origin"
                sandbox="allow-scripts allow-same-origin"
                @load="handleIframeLoad"
              />
            </ClientOnly>
          </div>
        </div>

        <!-- Центральный элемент -->
        <div class="hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
          <FlipCard />
        </div>

        <!-- Правая часть -->
        <div class="flex justify-end flex-row-reverse md:flex-row items-center gap-1 md:gap-2 z-10">
          <NuxtLink class="bg-primary/10 px-1 pr-4 rounded-full flex items-center gap-0 md:gap-2 hover:text-primary transition-colors" to="https://login.nebusfinance.ru">
            <NuxtImg
              src="/img/icon_payment.svg"
              alt="icon"
              class="block mx-auto"
              style="width: 40px; height: 40px"
            />
            <span class="block text-sm md:text-base">Оплатить</span>
          </NuxtLink>
          <NuxtLink to="https://login.nebusfinance.ru" external aria-label="Личный кабинет" class="p-2 flex items-center gap-2 justify-center hover:text-primary rounded-lg">
            <CircleUser class="size-6" />
            <span class="hidden lg:block">Личный кабинет</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
</style>
